import { fetchGlobalStylesFields, fetchGlobalStylesObject, fetchThemePreset } from 'ContentData/api/GlobalStyles';
import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { GLOBAL_STYLES_FETCH } from 'ContentData/actions/ActionTypes';
import { mergeDeep } from 'ContentUtils/helpers/ObjectHelpers';
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
const fetchGlobalStylesAction = createGenericFetchAction(GLOBAL_STYLES_FETCH, async (options = {}, httpClient) => {
  const {
    bufferTheme
  } = options;
  // Fetch fields and the GS object (overrides + activePresetId/themeId) in parallel
  const [fields, {
    activePresetId,
    themeId,
    overrides
  }] = await Promise.all([fetchGlobalStylesFields(httpClient), fetchGlobalStylesObject({
    bufferTheme
  }, httpClient)]);
  const presetId = Routes.isUngated(gate('GlobalStyles:MultiThemeEnabled')) ? themeId : activePresetId;

  // If no preset is active, user overrides are the only source of truth
  if (!presetId) {
    return {
      fields,
      overrides
    };
  }

  // Fetch the active preset and deep merge its base styles with user overrides
  const presetStyles = await fetchThemePreset(presetId, httpClient);
  return {
    fields,
    overrides: mergeDeep(presetStyles, overrides)
  };
});
export const fetchGlobalStyles = (options = {}) => fetchGlobalStylesAction(options);